import React from 'react'
import { Alert, Form } from 'react-bootstrap'
import {
  GateOption,
  GateSelectOption,
  getGateCode
} from '../../config/gates'

type GateSelectorProps = {
  options: GateSelectOption[]
  selectedGate: GateOption | null
  isLoading: boolean
  error: string
  onChange: (code: string) => void
}

export default function GateSelector({
  options,
  selectedGate,
  isLoading,
  error,
  onChange
}: GateSelectorProps) {
  const selectedGateCode = getGateCode(selectedGate)

  return (
    <div className="gate-selector-bar">
      <Form.Group className="gate-selector-field" controlId="gate-selector">
        <Form.Label>Portão</Form.Label>
        <Form.Select
          value={selectedGateCode}
          disabled={isLoading || options.length === 0}
          onChange={(event) => onChange(event.target.value)}
        >
          <option value="">
            {isLoading ? 'Carregando portões...' : 'Portão Atual N/A'}
          </option>
          {options.map((option) => (
            <option
              key={option.gateId || `${option.value || ''}-${option.label}`}
              value={option.value || ''}
            >
              {option.label}
            </option>
          ))}
        </Form.Select>
      </Form.Group>

      {error && (
        <Alert variant="warning" className="gate-selector-alert">
          {error}
        </Alert>
      )}
    </div>
  )
}
